import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from 'vuex-persist'
const vuexPersist = new VuexPersist({
    key: 'genoplot-persist',
    storage: sessionStorage
})
Vue.use(Vuex);
var settings = {
    slider: {
        batches: {
            value: 200,
            data: [100, 200, 400, 500, 600, 800, 1000]
        },
        cycles: {
            value: 200,
            data: [100, 200, 400, 500, 600, 800, 1000]
        },
        maxfits: {
            value: 20,
            data: [20, 100, 200, 500, 600, 800, 1000]
        },
        colors: {
            value: "1",
            data: ["1", "2", "3", "4", "5"]
        },
        layout: {
            value: "Chart",
            data: ["Chart", "Data", "Both"]
        }
    },
    switches: {
        defaultOn: true,
        defaultOff: false,
        scaled: true,
        paidPlan: true,
        basePlan: false,
        removeOutliers: false,
        penalty: true,
        groupAveraged: false,
        groupMedian: false,
        optimaFit: false,
        groupSamples: false,
    }
}
var data = {
    slideWrapper: 'visible',
    proceduresArr: [],
    instructionsArr: [],
    statusArr: ['Active', 'Inactive'],
    stagesArr: ['Approved', 'Draft'],
    policiesArr: [],
    authState: 'signIn',
    g25firstRun: true,
    graphQLurl: false,
    primaryTabs: "",
    secondaryTabs: "",
    onLine: true,
    activePane: 'chart',
    checkFitsData: [],
    changes: {},
    credits: 0,
    env: window.location.hostname.split('.')[0] === "staging" ? 'staging' : window.location.hostname === 'localhost' ? 'development' : 'production',
    currentIndex: 0,
    subId: false,
    statusMessage: '',
    g25expand: 0,
    theme: null,
    fadeIn: false,
    showGrid: 0,
    chartType: 'radialBar',
    geo: {},
    target: false,
    user: false,
    lastSort: false,
    lastQuery: false,
    spinner: false,
    cbInstance: false,
    subscription: false,
    subsActive: false,
    sampleArray: [],
    groupArray: [],
    g25chartJSON: false,
    g25chartColors: false,
    g25chartCategories: [],
    g25chartLoading: false,
    g25chartRunning: false,
    g25chartSeries: [],
    g25chartComponents: [],
    userSamples: [],
    editSamples: [],
    g25chartKey: false,
    lastUpdate: false,
    userUpdated: false,
    switches: settings.switches,
    slider: settings.slider,
}
data.init = JSON.stringify(data);
export const store = new Vuex.Store({
    state: data,
    mutations: {
        change(state, props) {
            var key = Object.keys(props)[0];
            var val = props[key];
            state[key] = val;
        }
    },
    getters: {
        get: (state) => (prop) => {
            return state[prop]
        }
    },
    plugins: [vuexPersist.plugin]
})
